import { render, staticRenderFns } from "./VideoTimeline.vue?vue&type=template&id=fc95b968&scoped=true&"
import script from "./VideoTimeline.vue?vue&type=script&lang=ts&"
export * from "./VideoTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./VideoTimeline.vue?vue&type=style&index=0&id=fc95b968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc95b968",
  null
  
)

export default component.exports